import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/Rx';
import { PopoverController } from 'ionic-angular';

@Injectable()
export class GlobalProvider {
  //PRODUCCION
  public web: string = "https://app.tactilevents.com/";
  public api: string = "https://ws.tactilevents.com/api/";
  public ruta: string = "https://ws.tactilevents.com/api/uploads/";
 
  //DESARROLLO
  //public api: string = "https://ws2.tactilevents.com/ws/api/";
  //public ruta: string = "https://ws2.tactilevents.com/ws/api/uploads/";

  public ficha_usuario = {};
  public usuario = 0;

  public clave_asistente = 0;

  //CLAVE INTERNA DEL CONGRESO EN CASO DE SER APP ESPECIFICA EJEM serau->public aplicacion=146;
  //public aplicacion = 191;
  public aplicacion = 0;
  public bbdd = "tactileventsreal.db";
  //CLAVE APP TABLA APLICACIONES
  public cod_aplicacion = 1;
  public version_app=3;
  
  public guid = "";
  public password = "";
  public token = "";
  public tema = 1;
  public fuente = 24;
  public clase: string = "botonaccion";
  public esbackoffice =true;
  public espwa = true;
  public esprueba = 0;
  public carga_inicial = 0;
  public primeracarga = true;
  public usuario_desplegado = 1;
  //public ficha_asistente: { clave?:'',nombre?: '',empresa?:'',cargo?: '' ,mail?: '',password?:'',clavecongreso?:'',imagen?:'' }= {};
  public ficha_asistente: {
    clave?: '', nombre?: '', empresa?: '', cargo?: '', mail?: '', twitter?: '', instagram?: '', telefono?: '', biografia?: '', organizacion?: '', password?: '', facebook?: '', linkedin?: '', inscripcion?: '', crea_reuniones?: '', inscrito_reuniones?: '', mostrar_lista_asistentes?: '',
    clavecongreso?: '', dispositivo?: '', imagen?: '',politica?:any
  } = {};
  public congresomenu: { clave?: '', nombre?: '', imgcabecera?: '', imgcartel?: '', imgicono?: '', imgpresentacion?: '',
  politica?: '' } = {}
  private theme: BehaviorSubject<String>;
  public nombretema;
  public menuglobal;
  public patrocinadores;
  public noti_chat;
  public estado_conexion=true;
  public noti_estado_conexion=false;
  public refreschats = [];
  public notificacionespendientes=0;
  /*  public congresoglobal: {
      clave?: '', nombre?: any, descripcion?: '', idioma?: '', claveusuario?: any, password?: '', fecha?: any, imgicono?: '', imgcartel?: '', imgpresentacion?: '', imgcabecera?: any, publicidad?: number, publico?: number, tema?: '', color_cabecera?: '', columnas_boton?: any, tipo_boton?: '',
      color_boton?: '', borde_boton?: '',color_borde_boton?: '', color_subcabecera?: '', color_fondo_inicio?: '', color_fondo_resto?: '', color_texto_boton?: '',
      color_fuente_titulo1?: '', color_fuente_titulo2?: '', color_fondo_titulo1?: '', color_fondo_titulo2?: '', color_fuente1?: '', color_fuente2?: '', color_fuente3?: '',color_fuente_desc_corta?:'',color_fuente_desc_larga?:'',color_fuente_fecha?:'',
      color_fondo_fecha_titulo_1?: '',color_fondo_fecha_titulo_2?: '',color_texto_fecha_titulo_1?: '',color_texto_fecha_titulo_2?: '',
  color_subtexto_fecha_titulo_1?: '',color_subtexto_fecha_titulo_2?: '',fuente?:'',color_titulo_principal?:'',color_fuente_cabecera?:''
    } = {};*/
  public numero_carga;
  public numero_total;
  public titulo_carga;
  public popover_abierto = false;
  public popover = this.popoverCtrl.create('page-progreso', {}, { cssClass: 'carga_popup' });
  public congresoglobal: {
    clave?: '', nombre?: any, descripcion?: '', idioma?: any, claveusuario?: any, password?: '', fecha?: any, imgicono?: '', imgcartel?: '', imgpresentacion?: '', imgcabecera?: any, publicidad?: number, publico?: number, tema?: '', columnas_boton?: any, tipo_boton?: '',
    color_boton?: '', borde_boton?: '', color_borde_boton?: '',
    color_texto_boton?: '',
    fuentetitulos?: '',
    fuentetextos?: '',
    colorfondo?: '',
    colortextofondo?: '',
    colorfondodetalle?: '',
    colortextofondodetalle?: '',
    colorfondocabecera?: '',
    colortextocabecera?: '',
    colorfondosubcabecera?: '',
    colortextosubcabecera?: '',
    colorfondosubsubcabecera?: '',
    colortextosubsubcabecera?: '',
    politica?: '',reuniones_pasadas?:'',tipo_grafico?:'',mostrarvotos?:'',texto_asistentes?:any,texto_reuniones?:any, 
    texto_ponentes?:any, 
    texto_programa?:any, 
    texto_documentos?:any, 
    texto_links?:any, 
    texto_encuestas?:any, 
    texto_votaciones?:any, 
    texto_patrocinadores?:any, 
    texto_notificaciones?:any, 
    texto_salas?:any,
    texto_comentarios?:any
  } = {};
  public clave_asistente_destino;
  public clave_asistente_origen;
  public clave_reunion;
  public chats = [];
  public listamenu;
  constructor(public popoverCtrl: PopoverController) {
    this.theme = new BehaviorSubject('dark-theme');
    this.menuglobal = [
    ]
  }

  setActiveTheme(val) {
    this.theme.next(val);
    this.nombretema = val;
  }

  getActiveTheme() {
    return this.theme.asObservable();
  }
  //////////////////////////////////////////////
  ////////////ESTILO//////////////////////////////////
  ///////////////////////////////////////////////

  clase_chip() {
    let styles = {
      'background': this.congresoglobal.colorfondocabecera,
      'color': this.congresoglobal.colortextocabecera,
      'font-family': this.congresoglobal.fuentetextos
    };

    return styles;
  }

  label_chip() {

    let styles = {
      'font-size': '14px !important',
      'line-height': '2!important'
    };

    return styles;
  }
  estilo_cuerpo_principal() {
    let styles = {
      //'margin-top': '-56px',
      'background-color': this.congresoglobal.colorfondo,
      'color': this.congresoglobal.colortextofondo

    };

    return styles;
  }
  etiqueta_card(item) {
    console.log(item);
    let styles = {
      'background': item.colorfondocabecera,
      'color': item.colortextocabecera,
      'font-family': item.fuentetitulos,
      'border-radius': '10px',
   // 'border-top': '15px solid rgb(0, 0, 0)',
   // 'border-bottom': '15px solid rgb(0, 0, 0)',
    'border-left': '8px solid rgb(0, 0, 0)',
    'border-right': '8px solid rgb(0, 0, 0)'
    };

    return styles;
    
  }
  estilo_cuerpo_principal_menu() {
    let styles = {
      //'margin-top': '-56px',
      'background-color': 'transparent',
      'color': this.congresoglobal.colortextofondo

    };

    return styles;
  }
  estilo_cuerpo_principal_noti() {
    let styles = {
      'color': this.congresoglobal.colortextofondo,
      'background-color': 'transparent !important',
      'font-size': '2rem',
      'width': ' 40px',
      'height': '40px',
      'margin-right': '15px'


    };

    return styles;
  }
  estilo_cuerpo_principal_noti2() {
    let styles = {
      'color': this.congresoglobal.colortextofondo

    };

    return styles;
  }
  estilo_cuerpo() {
    let styles = {
      'margin-top': '0px !important',
      'background-color': this.congresoglobal.colorfondodetalle,
      'cuerpo': this.congresoglobal.colortextofondodetalle,
      'padding-left':'0px'
    };

    return styles;
  }
  estilo_cuerpo_sin_margen() {
    let styles = {
      'margin-top': '0px',
      'margin-left': '0px',
      'background-color': this.congresoglobal.colorfondodetalle,
      'cuerpo': this.congresoglobal.colortextofondodetalle
    };

    return styles;
  }
  estilo_cuerpo_espacio(){
    let styles = {
      'margin-top': '0px !important',
      'background-color': this.congresoglobal.colorfondodetalle,
      'cuerpo': this.congresoglobal.colortextofondodetalle
    };

    return styles;
  }
  round_button1_izq() {
    let styles = {
      ' margin': '0px auto',
      'width': '100%',
      'display': 'flex',
      'flex-direction': 'row',
      'flex-wrap': 'wrap',
      'justify-content': 'left',
      'align-content': 'left',
      'align-items': 'left'

    };

    return styles;
  }
  round_button1() {
    let styles = {
      ' margin': '0px auto',
      'width': '100%',
      'display': 'flex',
      'flex-direction': 'row',
      'flex-wrap': 'wrap',
      'justify-content': 'center',
      'align-content': 'center',
      'align-items': 'center'

    };

    return styles;
  }
  round_button_circle() {
    if(this.congresoglobal.columnas_boton == "25%") {
    var margenes='0px';
    }else{
      var margenes='5px';
    }
    let styles = {
      'margin': margenes,
      'width': this.congresoglobal.columnas_boton,
      'height': '30%',
      'max-width': '300px',
      'max-height': '300px',
      'background-color': this.congresoglobal.color_boton,
      'border-radius': this.congresoglobal.tipo_boton,
      // padding-bottom: 90%;
      //'border': this.congresoglobal.borde_boton+' solid #fff',
      'border': this.congresoglobal.borde_boton + ' solid ' + this.congresoglobal.color_borde_boton,
      'overflow': 'initial',

      //  'background': this.congresoglobal.color_boton  
    };

    return styles;

  }
  botones_enlace() {
    let styles = {
      'margin': '5px',
      'width': this.congresoglobal.columnas_boton,
      //'height': '30%',
      'max-width': '300px',
      'max-height': '300px',
      // padding-bottom: 90%;
      'border-radius': '0%',
      //'border': this.congresoglobal.borde_boton+' solid #fff',
      'border': '0px solid #fff',
      'overflow': 'hidden',

      //  'background': this.congresoglobal.color_boton  
    };

    return styles;

  }
  boton_enlace() {

    var padding = '20%';

    let styles = {
      ' display': 'block',
      'float': 'left',
      'width': '100%',

      'padding-top': padding,
      'padding-bottom': padding,
      'line-height': '1em',
      'margin-top': '-0.5em',
      'margin-bottom': '-0.5em',
      'text-align': 'center',
      'color': this.congresoglobal.colortextocabecera,
      'background-color': this.congresoglobal.colorfondocabecera,
      'font-family': this.congresoglobal.fuentetitulos,
      'font-size': '1.1em',
      'font-weight': 'bold',
      'text-decoration': 'none',
      'webkit-box-shadow': 'none !important'
    };

    return styles;
  }
  boton_enlace_participante() {

    var padding = '20%';

    let styles = {
      ' display': 'block',
      'float': 'left',
      'width': '60px',
      'height': '60px',
      'border-radius': '50%',
      'padding-top': padding,
      'padding-bottom': padding,
      'line-height': '1em',
      'margin-top': '-0.5em',
      'margin-bottom': '-0.5em',
      'text-align': 'center',
      'color': this.congresoglobal.colortextocabecera,
      'background-color': this.congresoglobal.colorfondocabecera,
      'font-family': this.congresoglobal.fuentetitulos,
      'font-size': '1.1em',
      'font-weight': 'bold',
      'text-decoration': 'none',
      'webkit-box-shadow': 'none !important'
    };

    return styles;
  }
  round_button_texto() {
    if (this.congresoglobal.columnas_boton == "30%") {
      var size = '0.3em';

    } else {
      var size = '0.45em';
    }
    let styles = {
      'font-size': size,
      'font-weight': 'bold',
      'font-family': this.congresoglobal.fuentetextos
    };

    return styles;
  }
  round_button2() {
    /*if (this.congresoglobal.columnas_boton == "30%") {
      var padding = '50%';
      var alto = '3.6rem';
    } else {
      var padding = '10%';

      var alto = 'auto';
    }*/
    if (this.congresoglobal.columnas_boton == "30%") {
      var padding = '50%';
      var alto = '3.6rem';
      var sizefuente = '0.8em'
    } else if(this.congresoglobal.columnas_boton == "25%") {
      var padding = '50%';
      var alto = '3.6rem';
      var sizefuente = '0.3em'
    }else{
      var padding = '50%';
      var alto = '3.6rem';
      var sizefuente = '0.5em'
    }
    let styles = {
      'float': 'left',
      'width': '100%',
      'height': alto,
      'border-radius': this.congresoglobal.tipo_boton,
      'padding-top': padding,
      'padding-bottom': padding,
      'padding-left': '0px',
      'padding-right': '0px',
      'margin': '0px',
      'line-height': '1em',
      'text-transform': 'none',
      // 'margin-top': '-0.5em',
      // 'margin-bottom': '-0.5em',
      'text-align': 'center',
      'color': this.congresoglobal.color_texto_boton,
      'background-color': this.congresoglobal.color_boton,
      'font-family': this.congresoglobal.fuentetextos,
      'font-size': sizefuente,
      'font-weight': 'bold',
      'text-decoration': 'none',
      'webkit-box-shadow': 'none !important'
    };

    return styles;
  }
  round_button2_imagen(x) {
    //  var ruta = 'assets/im_menu/' + x;
    //  var ruta = this.ruta+this.congresoglobal.clave+'/'+x;
    if (this.congresoglobal.columnas_boton == "30%") {
      var padding = '50%';
      var alto = '3.6rem';
      var sizefuente = '0.8em'
    } else if(this.congresoglobal.columnas_boton == "25%") {
      var padding = '50%';
      var alto = '3.6rem';
      var sizefuente = '0.3em'
    }else{
      var padding = '50%';
      var alto = '3.6rem';
      var sizefuente = '0.5em'
    }
    let styles = {
      //'background-image': 'url("' + ruta + '")',
      'background-image': 'url("' + x + '")',
      'float': 'left',
      'width': '100%',
      'height': alto,
      'border-radius': this.congresoglobal.tipo_boton,
      'padding-top': padding,
      'padding-bottom': padding,
      'padding-left': '0px',
      'padding-right': '0px',
      'margin': '0px',
      'line-height': '1em',
      'text-transform': 'none',
      // 'margin-top': '-0.5em',
      // 'margin-bottom': '-0.5em',
      'text-align': 'center',
      'color': this.congresoglobal.color_texto_boton,
      'background-color': this.congresoglobal.color_boton,
      //  'background-image': 'url("' + ruta + '")',
      'background-repeat': 'no-repeat',
      'background-attachment': 'inherit',
      'background-position': 'center',
      'font-family': this.congresoglobal.fuentetextos,
      'font-size': sizefuente,
      'font-weight': 'bold',
      'text-decoration': 'none',
      'webkit-box-shadow': 'none !important'

    };

    return styles;
  }
  round_button_icono() {
    if (this.congresoglobal.columnas_boton == "30%") {
      var size = '3.2em';

    } else {
      var size = '5.9em';
    }
    let styles = {

      'font-size': size
    };

    return styles;
  }
  cabecera_titulo() {
    let styles = {
      'background': this.congresoglobal.colorfondocabecera,
      'color': this.congresoglobal.colortextocabecera,
      'font-family': this.congresoglobal.fuentetitulos,
      'font-size': '20px'
    };

    return styles;

  }
  cuadro_envia() {
    let styles = {
      'background': this.congresoglobal.colorfondocabecera,
      'color': this.congresoglobal.colortextocabecera,
      'font-family': this.congresoglobal.fuentetitulos,
      'font-size': '12px'
    };

    return styles;

  }
  subcabecera_titulo() {
    let styles = {
      'border-color': this.congresoglobal.colorfondosubcabecera,
      'background': this.congresoglobal.colortextosubcabecera,
      'padding': '0px',
      'min-height': '40px',
      'font-family': this.congresoglobal.fuentetitulos
      // 'color': '#fff'
    };

    return styles;

  }
  subcabecera_buscar() {
    let styles = {
      'border-color': this.congresoglobal.colorfondosubcabecera,
      'background': this.congresoglobal.colortextosubcabecera,
      'padding': '0px',
      'min-height': '40px',
      'font-family': this.congresoglobal.fuentetitulos
      // 'color': '#fff'
    };

    return styles;

  }
  subcabecera_lateral_c() {
    let styles;
    if (this.congresoglobal.clave) {
      styles = {
       // 'background': '#d2edf3',
       // 'color': '#fff',
        'background': this.congresoglobal.colorfondocabecera,
        'color': this.congresoglobal.colortextocabecera,
        'margin': '0px'
        // 'color': '#fff'
      };
    } else {
      styles = {
        //  'background': '#233746 ',
        'background': '#d2edf3',
        'color': '#fff',
        'margin': '0px'
        // 'color': '#fff'
      };
    }


    return styles;

  }
  subcabecera_lateral_ca() {
    let styles;
   
      styles = {
       // 'background': '#d2edf3',
       // 'color': '#fff',
        'background': this.congresoglobal.colorfondocabecera,
        'color': this.congresoglobal.colortextocabecera,
        'margin': '0px'
        // 'color': '#fff'
      };
    
    


    return styles;

  }
  subcabecera_lateral_inverso() {
    let styles;
    styles = {
      'background': '#fff',
      'color': '#000',
      'margin': '0px'

    };

    return styles;

  }
  subcabecera_lateral() {
    let styles;
    if (this.congresoglobal.clave) {

      styles = {
        //  'background': this.congresoglobal.colorfondocabecera,
        // 'color': this.congresoglobal.colortextocabecera,
        'background': '#d2edf3',
        'color': '#fff',
        'margin': '0px'

      };
    } else {
      styles = {
        //  'background': '#233746',
        'background': '#36b4e5',
        'color': '#fff',
        'margin': '0px'

      };
    }

    return styles;

  }
  subcabecera_lateral_fija() {
    let styles;
    //'background': '#233746',
    styles = {
      'min-height': '5px !important',
      'background': '#d2edf3',
      'color': '#fff',
      'margin': '0px'
     


    }

    return styles;

  }
  subcabecera_lateral_foto() {
    let styles;


    styles = {
    /*  'background-image': 'url("assets/imgs/cabecera_menu2.jpg")',
      'background-size': 'cover',*/
      'background':'#d2edf3',
      'color': '#fff',
      'margin': '0px',
      'max-height': '200px'
    };


    return styles;

  }
  subcabecera_lateral_foto_backoffice() {
    let styles;


    styles = {
      'background-color': '#fff',
      'background-size': 'cover',
      'color': '#fff',
      'margin': '0px',
      'height': '115px'
    };


    return styles;

  }
  subcabecera_lateral_login() {
    /*let styles = {
      'background': '#4caf50',
      'color': '#fff'

    };*/
    let styles = {
      'background': 'transparent',
      'color': '#fff'

    };
    return styles;

  }
  subcabecera_lateral_logout() {
    let styles = {
      // 'background': '#FF9800',
      'background': 'transparent',
      'color': '#fff'


    };

    return styles;

  }
  boton_nuevo() {
    let styles = {
      'background': this.congresoglobal.colorfondocabecera,
      'color': this.congresoglobal.colortextocabecera

      // 'color': '#fff'
    };

    return styles;

  }
  boton_nuevo_v2() {
    let styles = {
      //'background': 'transparent',
      //'color': this.congresoglobal.colortextofondodetalle
      'background-color': this.congresoglobal.colorfondosubcabecera,
      'color': this.congresoglobal.colortextosubcabecera,
      // 'color': '#fff'
    };

    return styles;

  }
  boton_nuevo_outline() {
    let styles = {
      'background': 'transparent',
      'color': this.congresoglobal.colortextofondodetalle,
      'border-color': this.congresoglobal.colortextofondodetalle

      // 'color': '#fff'
    };

    return styles;

  }
  boton_nuevo_inverso() {
    let styles = {
      'background': this.congresoglobal.colortextocabecera,
      'color': this.congresoglobal.colorfondocabecera,
      'font-size': '12px'

      // 'color': '#fff'
    };

    return styles;

  }
  subcabecera_opciones() {
    let styles = {
      //   'background-color': this.congresoglobal.colorfondosubcabecera,
      'background-color': this.congresoglobal.colorfondocabecera,
      'height': '40px !important'
    };

    return styles;
  }
  subcabecera_opciones_backoffice() {
    let styles = {
      //   'background-color': this.congresoglobal.colorfondosubcabecera,
      'background-color': '#d2edf3',
      'height': '40px !important'
    };

    return styles;
  }
  etiqueta_titulo() {
    let styles = {
      'color': this.congresoglobal.colortextofondodetalle,
      'font-size': '2.0rem',
      'font-family': this.congresoglobal.fuentetitulos
    };

    return styles;

  }
  etiqueta_titulo_programa() {
    let styles = {
      'color': this.congresoglobal.colortextofondodetalle,
      'font-size': '2.0rem',
      'text-align': 'center',
      'font-family': this.congresoglobal.fuentetitulos
    };

    return styles;

  }
  etiqueta_titulo_programa_imagen() {
    let styles = {
      'color': this.congresoglobal.colortextofondodetalle,
      'font-size': '2.0rem',
      'text-align': 'left',
      'font-family': this.congresoglobal.fuentetitulos
    };

    return styles;

  }
  etiqueta_lateral() {
    let styles = {
      'color': this.congresoglobal.colorfondosubcabecera,
      'font-size': '1.2rem'

    };

    return styles;

  }
  etiqueta_lateral_inverso_desplegable() {
    let styles = {
      'color': '#000',
      'font-size': '1.4rem',
      'background-color': '#d2edf3'

    };

    return styles;

  }
  etiqueta_lateral_inverso() {
    let styles = {
      'color': '#000',
      'font-size': '1.4rem',
      'background-color': '#d2edf3'

    };

    return styles;

  }
  etiqueta_lateral_inversoapp() {
    let styles = {
      'color': '#1a2c3b',
      'font-size': '1.2rem',
      'background-color': '#fff'

    };

    return styles;

  }
  etiqueta_lateral_inverso_pie() {
    let styles = {
      'color': '#464f56',
      'font-size': '1.2rem',
      'text-align':'center',
      'border': '0px solid #fff',
      'background-color':'#fff'

    };

    return styles;

  }
  opcion_noseleccionada() {
    let styles = {
      'background-color': this.congresoglobal.colorfondocabecera,
      'color': this.congresoglobal.colortextocabecera,
      //  'background-color': this.congresoglobal.colorfondosubcabecera,
      //  'color': this.congresoglobal.colortextosubcabecera,
      'margin': '0',
      'font-size': '12px',
      'height': '35px',
      'display': 'flex',
      ' -webkit-box-pack': 'center',
      ' -webkit-justify-content': 'center',
      ' -ms-flex-pack': 'center',
      'justify-content': 'center',
      ' -webkit-box-align': 'center',
      '-webkit-align-items': 'center',
      '-ms-flex-align': 'center',
      'align-items': 'center',
      'padding-left': '3px',
      'padding-right': '3px'
    };

    return styles;
  }
  opcion_noseleccionada_separadia() {
    let styles = {
      'background-color': this.congresoglobal.colorfondocabecera,
      'color': this.congresoglobal.colortextocabecera,
      //  'background-color': this.congresoglobal.colorfondosubcabecera,
      //  'color': this.congresoglobal.colortextosubcabecera,
      'margin': '0',
      'font-size': '12px',
      'height': '35px',
      'display': 'flex',
      ' -webkit-box-pack': 'center',
      ' -webkit-justify-content': 'center',
      ' -ms-flex-pack': 'center',
      'justify-content': 'center',
      ' -webkit-box-align': 'center',
      '-webkit-align-items': 'center',
      '-ms-flex-align': 'center',
      'align-items': 'center',
      //'padding-left': '3px',
      'padding-right': '3px'
    };

    return styles;
  }
  opcion_seleccionada() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'background-color': this.congresoglobal.colorfondosubcabecera,
      'color': this.congresoglobal.colortextosubcabecera,

      'margin': '0',
      'font-size': '12px',
      'height': '40px',
      'display': 'flex',
      ' -webkit-box-pack': 'center',
      ' -webkit-justify-content': 'center',
      ' -ms-flex-pack': 'center',
      'justify-content': 'center',
      ' -webkit-box-align': 'center',
      '-webkit-align-items': 'center',
      '-ms-flex-align': 'center',
      'align-items': 'center',
      'padding-left': '3px',
      'padding-right': '3px'
    };

    return styles;
  }
  opcion_noseleccionada_backoffice() {
    let styles = {
      'background-color': '#d2edf3',
      'color': '#00a8b9',
      'font-family': this.congresoglobal.fuentetitulos,
      //  'background-color': this.congresoglobal.colorfondosubcabecera,
      //  'color': this.congresoglobal.colortextosubcabecera,
      'margin': '0',
      'font-size': '12px',
      'height': '35px',
      'display': 'flex',
      ' -webkit-box-pack': 'center',
      ' -webkit-justify-content': 'center',
      ' -ms-flex-pack': 'center',
      'justify-content': 'center',
      ' -webkit-box-align': 'center',
      '-webkit-align-items': 'center',
      '-ms-flex-align': 'center',
      'align-items': 'center',
      'padding-left': '3px',
      'padding-right': '3px'
    };

    return styles;
  }

  opcion_seleccionada_backoffice() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'background-color': '#00a8b9',
      'color': '#fff',
      'font-family': this.congresoglobal.fuentetitulos,
      'margin': '0',
      'font-size': '12px',
      'height': '40px',
      'display': 'flex',
      ' -webkit-box-pack': 'center',
      ' -webkit-justify-content': 'center',
      ' -ms-flex-pack': 'center',
      'justify-content': 'center',
      ' -webkit-box-align': 'center',
      '-webkit-align-items': 'center',
      '-ms-flex-align': 'center',
      'align-items': 'center',
      'padding-left': '3px',
      'padding-right': '3px'
    };

    return styles;
  }
  boton_selec_backoffice() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'background-color': '#0a5471',
      'color': '#fff'
    };

    return styles;
  }
  boton_noselec_backoffice() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'background-color': '#fff',
      'color': '#000'
    };

    return styles;
  }

  boton_noselec_backoffice_gris() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'background-color': '#e7edef',
      'color': '#000'
    };

    return styles;
  }
  boton_pulsado() {
    let styles = {
      'font-size': '2rem',
      'border-radius': '50%',
      'width': '40px',
      'height': '40px',
      'color': this.congresoglobal.colortextosubcabecera,
      'background-color': this.congresoglobal.colorfondosubcabecera

    };

    return styles;
  }
  boton_nopulsado() {
    let styles = {
      'color': this.congresoglobal.colortextocabecera,
      'font-size': '2rem',
      'width': '40px',
      'height': '40px',
      'background-color': this.congresoglobal.colorfondocabecera
    };

    return styles;
  }

  separador_titulo() {
    let styles = {
      'color': this.congresoglobal.colortextosubcabecera,
      'background-color': this.congresoglobal.colorfondosubcabecera,
      'font-family': this.congresoglobal.fuentetitulos
    };

    return styles;
  }
  separador_titulo2() {
    let styles = {
      'color': this.congresoglobal.colortextosubsubcabecera,
      'background-color': this.congresoglobal.colorfondosubsubcabecera,
      'font-family': this.congresoglobal.fuentetitulos
    };

    return styles;
  }
  /* color_fecha() {
     let styles = {
       'color': '#F67F22',
       'font-size': '1.2rem',
       'text-align': 'left'
 
     };
 
     return styles;
   }*/


  color_fecha_titulo2() {
    let styles = {
      'color': this.congresoglobal.colortextosubsubcabecera,
      'font-size': '1.2rem',
      'text-align': 'left'

    };

    return styles;
  }

  color_fecha_titulo1() {
    let styles = {
      'color': this.congresoglobal.colortextosubcabecera,
      'font-size': '1.2rem',
      'text-align': 'left'

    };

    return styles;
  }
  color_fecha_texto1() {
    let styles = {
      // 'color': this.congresoglobal.color_subtexto_fecha_titulo_1,
      'font-size': '1.2rem',
      'text-align': 'left'

    };

    return styles;
  }
  color_fecha_texto2() {
    let styles = {
      //'color': this.congresoglobal.color_subtexto_fecha_titulo_2,
      'font-size': '1.2rem',
      'text-align': 'left'

    };

    return styles;
  }

  color_fecha_texto() {
    let styles = {
      'color': this.congresoglobal.colortextofondodetalle,
      'font-size': '1.2rem',
      'text-align': 'left'

    };

    return styles;
  }

  quitar_espacio() {
    let styles = {
      'margin': '0px',
      'padding': '0px'

    };

    return styles;
  }

  ancho_fecha_titulo2() {
    let styles = {
      'float': 'left',
      'width': '100%'

    };

    return styles;
  }
  fuente_texto() {
    let styles = {
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuentetextos,
      'font-weight': 'bold',
        'color': this.congresoglobal.colortextofondodetalle

    };

    return styles;
  }
  fuente_texto_reunion() {
    let styles = {
      'font-size': '1.9rem',
      'font-family': this.congresoglobal.fuentetextos,
      'font-weight': 'bold',
        'color': this.congresoglobal.colortextofondodetalle

    };

    return styles;
  }
  fuente_texto_submenu() {
    let styles = {
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuentetextos,
      //  'color': this.congresoglobal.colortextofondo

    };

    return styles;
  }
  fuente_texto2() {
    let styles = {
      'font-size': '1.2rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle

    };
    return styles;
  }
  fuente_texto2_reunion() {
    let styles = {
      'font-size': '1.0rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle

    };
    return styles;
  }
  fuente_texto3() {
    let styles = {
      'font-size': '3.4rem',
      //'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle

    };


    return styles;
  }
  fuente_texto4() {
    let styles = {
      'padding-left':'10px',
      'font-size': '3.2rem',
      'color': this.congresoglobal.colortextofondodetalle


    };


    return styles;
  }
  fuente_texto5() {
    let styles = {
      'font-size': '1.8rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextosubcabecera


    };


    return styles;
  }
  fuente_texto5p() {
    let styles = {
      'font-size': '1.2rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextosubcabecera


    };


    return styles;
  }
  fuente_texto5_titulo() {
    let styles = {
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle


    };


    return styles;
  }
  fuente_texto5_gris() {
    let styles = {
      'font-size': '2.1rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': '#c4c4c4'


    };


    return styles;
  }
  titulo1() {
    //this.congresoglobal.colortextosubcabecera
    let styles = {
      'border-bottom': '7px solid' + this.congresoglobal.colorfondosubcabecera,
      'color': this.congresoglobal.colortextofondodetalle,
      'font-family': this.congresoglobal.fuentetitulos,
      'background-color': this.congresoglobal.colorfondodetalle,
      'font-size':'2.3rem'
    };
    return styles;
  }
  titulo2() {
    let styles = {
      'color': this.congresoglobal.colortextosubsubcabecera,
      'background-color': this.congresoglobal.colorfondosubsubcabecera,
      'font-family': this.congresoglobal.fuentetitulos
    };
    return styles;
  }
  splash_bg() {
    let styles = {
      'position': 'relative',
     // 'background-color': this.congresoglobal.colorfondosubcabecera,
      'background-size': 'cover',
      'height': '10%',
      'z-index': '1',
      'background-repeat': 'repeat-x',
      '-webkit-animation': 'animatedBackground 40s linear infinite',
      'animation': 'animatedBackground 40s linear infinite'
    };
    return styles;
  }
  splash_info() {
    let styles = {
      'position': 'relative',
      'z-index': '2',
      'margin-top': '-64px',
      'text-align': 'center'
    };
    return styles;
  }
  splash_intro() {
    let styles = {
      'font-size': '1.5rem !important',
      'font-weight': 'bold',
      'max-width': '100%',
      'margin': 'auto',
      'text-align': 'center',
      'font-family': this.congresoglobal.fuentetitulos,
      'color': '#000'
    };
    return styles;
  }
  fuente_descripcion_corta() {
    let styles = {
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle

    };

    return styles;
  }
  fuente_descripcion_corta_splash_intro() {
    let styles = {
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle,
      'margin-top': '4px'

    };

    return styles;
  }
  fuente_descripcion_larga() {
    let styles = {
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle

    };

    return styles;
  }
  fuente_descripcion_larga_2() {
    let styles = {
      'font-size': '1.2rem',
      'font-family': this.congresoglobal.fuentetextos,
      'color': this.congresoglobal.colortextofondodetalle

    };

    return styles;
  }
  fuente_descripcion_larga_gris() {
    let styles = {
      'font-family': this.congresoglobal.fuentetextos,
      'color': '#cccccc'

    };

    return styles;
  }
  etiqueta_chip() {
    let styles = {
      'text-align': 'center !important',
      'border-radius': '50% !important',
      'width': '24px !important',
      'height': '24px !important',
      'font-size': '14px !important',
      'line-height': '24px !important',
      'color': '#fff !important',
      'background': this.congresoglobal.colorfondocabecera

    };

    return styles;
  }

  boton_range() {
    let styles = {
      'color': this.congresoglobal.colorfondocabecera,
      'background-color': 'transparent',
      //'background-color': '#fff',
      //'color': '#10bde8'
    };

    return styles;
  }
  fuente_texto_encuesta() {
    let styles = {
      'color': this.congresoglobal.colorfondocabecera,
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuentetextos,


    };

    return styles;
  }

  /*etiqueta_encuesta() {
    let styles = {
      'margin-bottom': '0px',
      'font-size': '1.5rem',
      'font-family': this.congresoglobal.fuente,
      'color': '#10bde8'
    };

    return styles;
  }*/
  encuesta_opcion_noseleccionada() {
    let styles = {
      //'background-color': this.congresoglobal.color_subcabecera,
      'margin': '5px',
      'font-size': '12px',
      'height': '35px',
      'width': '15%',
      'display': 'flex',
      ' -webkit-box-pack': 'center',
      ' -webkit-justify-content': 'center',
      ' -ms-flex-pack': 'center',
      'justify-content': 'center',
      ' -webkit-box-align': 'center',
      '-webkit-align-items': 'center',
      '-ms-flex-align': 'center',
      'align-items': 'center',
      'padding-left': '3px',
      'padding-right': '3px'
    };

    return styles;
  }

  encuesta_opcion_seleccionada() {
    let styles = {
      'background-color': this.congresoglobal.colorfondocabecera,
      'color': this.congresoglobal.colortextocabecera,
      'margin': '5px',
      'font-size': '12px',
      'height': '40px',
      'width': '15%',
      'display': 'flex',
      ' -webkit-box-pack': 'center',
      ' -webkit-justify-content': 'center',
      ' -ms-flex-pack': 'center',
      'justify-content': 'center',
      ' -webkit-box-align': 'center',
      '-webkit-align-items': 'center',
      '-ms-flex-align': 'center',
      'align-items': 'center',
      'padding-left': '3px',
      'padding-right': '3px'
    };

    return styles;
  }

  separador_titulo_car() {
    let styles = {
      'color': this.congresoglobal.colortextosubcabecera,
      'background-color': this.congresoglobal.colorfondosubcabecera,
      'font-size': ' 1.0rem'

    };
    return styles;
  }
  cuerpo_car() {
    let styles = {
      'padding': '16px'

    };
    return styles;

  }
  boton_estilo() {

    var padding = '0%';

    let styles = {
      ' display': 'block',
      'float': 'left',
      'width': '150px',
      'height': '150px',
      'padding-top': padding,
      'padding-bottom': padding,
      'line-height': '1em',
      'margin-top': '-0.5em',
      'margin-bottom': '-0.5em',
      'text-align': 'center',
      'border-radius': this.congresoglobal.tipo_boton,
      'color': this.congresoglobal.color_texto_boton,
      'background-color': this.congresoglobal.color_boton,
      'font-family': this.congresoglobal.fuentetitulos,
      'font-size': '1.1em',
      'font-weight': 'bold',
      'text-decoration': 'none',
      'webkit-box-shadow': 'none !important',
      'border': this.congresoglobal.borde_boton + ' solid ' + this.congresoglobal.color_borde_boton
    };

    return styles;
  }
  /*.range-md .range-knob {
    left: 12px;
    top: 13px;
    border-radius: 50%;
    position: absolute;
    z-index: 2;
    width: 18px;
    height: 18px;
    background: #106eb0;*/
  //////////////////////////////////////////////
  ////////////FIN ESTILO//////////////////////////////////
  ///////////////////////////////////////////////


  //////////////////////////////////////
  /////////////ESTILO BACKOFFICE////////////////////////
  /////////////////////////////////////
  cabeceratitulo_app() {
    let styles = {
      'border-color': '#000',
      'background': '#000',
      'color': '#fff',
      'font-size': '20px !important'
    };

    return styles;

  }
  subcabeceratitulo_app() {
    /**
     * 'border-color': '#243746',
      'background': '#d2edf3', 
       'color': '#fff'
     */
    let styles = {

      'border-color': '#dadada',
      'background': '#dadada',
      'color': '#000'
    };

    return styles;

  }
  subcabeceratitulo_app_inverso() {
    let styles = {
      'border-color': '#fff',
      'background': '#fff',
      'color': '#233746'
    };

    return styles;

  }
  cabeceratitulo_backoffice() {
    let styles = {
      'border-color': '#d2edf3',
      'background': '#d2edf3',
      'color': '#00a8b9',
      'font-size': '20px !important'
    };

    return styles;

  }
  subcabeceratitulo_backoffice() {
    let styles = {
      'border-color': '#d2edf3 ',
      'background': '#d2edf3',
      'color': '#000'
    };

    return styles;

  }
  row_backoffice() {
    let styles = {
      'border-color': '#d2edf3',
      'background': '#d2edf3',
      'color': '#000'
    };

    return styles;

  }
  boton_nuevo_backoffice() {
    let styles = {
      'border-color': '#000',
      'background': '#4caf50',
      'color': '#000',
      'border-radius': '50%',
      'width': '30px',
      'height': '30px'
    };

    return styles;

  }
  boton_editar_backoffice() {
    let styles = {
      'border-color': '#fff',
      'background': '#f58c29',
      'color': '#fff',
      'border-radius': '50%',
      'width': '30px',
      'height': '30px'
    };

    return styles;


  }
  boton_duplicar_backoffice() {
    let styles = {
      'border-color': '#fff',
      'background': '#00a8b9',
      'color': '#fff',
      'border-radius': '50%',
      'width': '30px',
      'height': '30px'
    };

    return styles;

  }
  boton_duplicar_backoffice_app() {
    let styles = {
      'border-color': '#fff',
      'background': '#00a8b9',
      'color': '#fff',
      'width': '55px'
    };

    return styles;

  }
  boton_editar_backoffice_app() {
    let styles = {
      'border-color': '#fff',
      'background': '#f58c29',
      'color': '#fff',
      'width': '55px'
    };

    return styles;

  }
  boton_editar_backoffice2() {
    let styles = {
      'border-color': '#fff',
      'background': '#f58c29',
      'color': '#fff',
      'border-radius': '64px',
      'width': '65px',
      'font-size':'10px'
     // 'height': '45px'
    };

    return styles;

  }
  boton_eliminar_backoffice() {
    let styles = {
      'border-color': '#f4313f',
      'background': '#f4313f',
      'color': '#fff',
      'border-radius': '50%',
      'width': '30px',
      'height': '30px'
    };

    return styles;

  }
  boton_eliminar_backoffice_app() {
    let styles = {
      'border-color': '#f4313f',
      'background': '#f4313f',
      'color': '#fff',
      'width': '55px'
    };

    return styles;

  }
  estilo_menu() {
    let styles = {
      'background': '#d2edf3',
      'font-size': '1.4rem',
      'color': '#fff',
      'min-height': '20px !important'
    };

    return styles;
  }
  estilo_submenu() {
    let styles = {
      'background': '#d2edf3',
      'padding-left': '50px',
      'font-size': '1.4rem',
      'color': '#000'
    };

    return styles;
  }
  estilo_submenu_desplegable() {
    let styles = {
      'background': '#d2edf3',
      'padding-left': '50px',
      'font-size': '1.2rem',
      'color': '#000'
    };

    return styles;
  }
  estilo_casillas_tabla() {
    let styles = {
      'padding':'0px',
      'border-bottom': '1px solid #dedede',
      'display': 'flex',
      'justify-conten': 'center',
      //'font-size': '2.0rem',
      'align-items': 'center',
      'text-align': 'left',
      'color': '#243746'
    };

    return styles;
  }
  casillabuscar() {
    let styles = {
      'border': '0!important',
      'box-shadow': 'none !important'
    };

    return styles;
  }
  boton_visualizar_app() {
    let styles = {
      'border-color': '#000',
      'background': '#fff',
      'color': '#000',
      'border-radius': '0px',
      'font-size': '2.0rem',
      'height': '47px',
      'margin': '5%',
      'width': '42%',
      'font-family': 'Lato_regular',
      'border': '2px solid #000'
    };

    return styles;

  }
  boton_visualizar_backoffice() {
    let styles = {
      'border-color': '#fff',
      'background': '#233746',
      'color': '#fff',
      'border-radius': '5px',
      'font-size': '1.6rem',
      'height': '30px'
    };

    return styles;

  }
  boton_agregar_backoffice() {
    let styles = {
      'border-color': '#000',
      'background': 'transparent',
      'color': '#000'
    };

    return styles;

  }
  boton_aceptar_backoffice() {
    let styles = {
      'border-color': '#fff',
      'background': '#4caf50',
      'color': '#fff',
      'border-radius': '50%',
      'width': '30px',
      'height': '30px'
    };

    return styles;

  }
  boton_cancelar_backoffice() {
    let styles = {
      'border-color': '#fff',
      'background': '#f44336',
      'color': '#fff',
      'border-radius': '50%',
      'width': '30px',
      'height': '30px'
    };

    return styles;

  }
  boton_seleccionado() {
    let styles = {
      'border-color': '#243745',
      'background': '#243745',
      'color': '#fff'
    };

    return styles;

  }
  boton_noseleccionado() {
    let styles = {
      'border-color': '#fff',
      'background': '#fff',
      'color': '#243745'
    };

    return styles;

  }
  etiqueta_label() {
    let styles = {
      'font-size': '1.4rem',
      'color': '#243746',
      'font-weight':'bold'
    };

    return styles;
  }
  input_label() {
    let styles = {
      'font-size': '1.4rem',
      'color': '#243745'
    };

    return styles;
  }
  etiqueta_foto_figura() {
    let styles = {
      'width': '50px',
      'height': '50px',
      'border-radius': '50%',
      'background-color': '#5bc6d2',
      'display': 'block',
      'padding': '12px',
      'margin': '0 auto 10px',
      'color':'#9cdc20'
    };
//#5bc6d2
    return styles;
  }


  etiqueta_foto() {
    let styles = {
      'width': '100%',
      'background-color': '#e7edef',
      //'border-radius': '5%',
      'border': '1px solid #dedede',
      'font-size': '1.25rem',
      'font-weight': '700',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap',
      'cursor': 'pointer',
      'display': 'inline-block',
      'overflow': 'hidden',
      'padding': '0.625rem 1.25rem',
      'color':'#000'
    };

    return styles;
  }
  etiqueta_foto_excel() {
    let styles = {
      'width': '100%',
      'background-color': '#FFF',
      'border-radius': '5%',
      'border': '0px solid #dedede',
      'font-size': '1.25rem',
      'font-weight': '700',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap',
      'cursor': 'pointer',
      'display': 'inline-block',
      'overflow': 'hidden',
      'padding': '0.625rem 1.25rem'
    };

    return styles;
  }
  etiqueta_indicadores() {
    let styles = {
      'font-size': '4.4rem',
      'background-color': '#243746'
    };

    return styles;
  }
  etiqueta_indicadores_lista() {
    let styles = {
      'font-size': '1.2rem',
      'background-color': '#243746'
    };

    return styles;
  }
  estilo_casillas_tabla_indicador() {
    let styles = {
      'border-bottom': '1px solid #dedede',
      'display': 'flex',
      'justify-conten': 'center',
      'font-size': '1.3rem',
      'align-items': 'center',
      'text-align': 'left',
      'color': '#243746'
    };

    return styles;
  }
  alto_cabecera(x,y) {
   
    var alto='10px';
    if(x>1){
    //  alert(1);
      alto='40px';
    }else if(y==true){
      //alert(2);
      alto='40px';
    }
   
    let styles = {
      'margin-top': alto
      // 'color': '#fff'
    };

    return styles;

  }
  
  fuente_texto_start() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'background-color': this.congresoglobal.colorfondosubcabecera,
      'color': this.congresoglobal.colortextosubcabecera,
      'text-align': 'center',
      'padding':'5px',
      'margin':'0px',
      'margin-right':'8px',
      'width':'75px'
    };

    return styles;
  }
  fuente_texto_start_r() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'background-color': this.congresoglobal.colorfondosubcabecera,
      'color': this.congresoglobal.colortextosubcabecera,
      'text-align': 'center',
      'padding-top':'5%',
      'padding-bottom':'5%',
      'padding-left':'2%',
      'padding-right':'2%',
      'margin':'0px',
      'margin-right':'8px'
    };

    return styles;
  }
  fuente_texto_end() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      
      'text-align': 'right',
      'padding':'0px',
      'margin':'0px',
      'margin-left': '10px'
    };

    return styles;
  }

  check_marca() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'min-height': '2.8rem',
    'font-size': '1.8rem',
    'line-height': '1',
    'color': this.congresoglobal.colorfondocabecera
   
    };

    return styles;
  }
  check_marca2() {
    let styles = {
      //  'background-color': this.congresoglobal.colorfondocabecera,
      //  'color': this.congresoglobal.colortextocabecera,
      'min-height': '2.8rem',
    'font-size': '1.8rem',
    'line-height': '1'
   
    };

    return styles;
  }
  //////////////////////////////////////
  /////////////ESTILO BACKOFFICE////////////////////////
  /////////////////////////////////////

}





// WEBPACK FOOTER //
// ./src/providers/global/global.ts